import React from 'react'
import { duplicateAllSequences } from '../gql'
import { useDispatch } from 'react-redux'
import { Box } from '@material-ui/core'
import {
  hideReduxModal,
  resetReduxModal,
  showReduxModal,
} from '../../../../../../Reducers/UI/actions'

export const useDuplicateSequence = ({ cityId, cityName, countryName }) => {
  const dispatch = useDispatch()

  const handleDuplicateSequence = async () => {
    const response = await duplicateAllSequences({ cityId })
    const payload = await response.json()
    const success = payload.data.duplicateAllSequences.success
    let message = {
      title: 'Failure',
      message: 'Failed to duplicate sequences',
    }
    if (success) {
      message = {
        title: 'Success',
        text: 'Sequences duplicated successfully',
      }
    }
    dispatch(
      showReduxModal({
        title: message.title,
        children: (
          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
            mt={3}
            mb={3}
          >
            {message.text}
          </Box>
        ),
        onConfirm: async () => {
          hideReduxModal()
          resetReduxModal()
        },
        hideCancel: true,
        aspect: 'nonScrollable',
      }),
    )
  }

  const onDuplicateSequence = () => {
    dispatch(
      showReduxModal({
        title: 'Confirmation needed',
        children: (
          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
            mt={3}
            mb={3}
          >
            {`This action will add all ops-made sequences from ${cityName} to every other city in ${countryName}. It may lead other cities having duplicated sequences. Are you sure?`}
          </Box>
        ),
        onConfirm: async () => {
          try {
            handleDuplicateSequence()
            hideReduxModal()
            resetReduxModal()
          } catch (error) {
            hideReduxModal()
            resetReduxModal()
            alert(`Error occured: ${error.message}`)
          }
        },
        onCancel: () => {
          hideReduxModal()
          resetReduxModal()
        },
        aspect: 'nonScrollable',
      }),
    )
  }

  return { onDuplicateSequence }
}
